import { Reveal, Eyebrow, YouTubeEmbed, GoldDivider } from "./Reveal";

export default function NadiPariksha() {
  return (
    <section id="nadi-pariksha" data-testid="nadi-pariksha-section" className="bg-[#FAF7F2] py-16 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <Reveal>
          <Eyebrow>Chapter 03 · The Assessment</Eyebrow>
          <h2 className="mt-5 font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1B3B2B] tracking-tight leading-tight">
            Nadi Pariksha
          </h2>
          <p className="mt-3 font-serif italic text-xl sm:text-2xl text-[#B85D43]">
            Understanding the Child Beyond What Can Be Seen
          </p>
          <p className="mt-6 text-base text-[#2D3A32] leading-relaxed">
            Nadi Pariksha is a traditional Ayurvedic assessment in which the pulse is examined to understand certain
            functional patterns within the body.
          </p>
          <p className="mt-4 text-base text-[#5C6E62] leading-relaxed">
            For children, this can offer an Ayurvedic perspective on patterns that they may not always be able to
            communicate themselves — including digestion, energy, sensory responses and daily rhythms.
          </p>
          <p className="mt-4 text-base text-[#5C6E62] leading-relaxed">
            Through Nadi Pariksha, Ayurvedic parameters such as Agni, Ama and Vata–Pitta–Kapha patterns are observed to
            understand the child's individual constitution and functional patterns.
          </p>
          <p className="mt-6 text-sm text-[#5C6E62] leading-relaxed italic font-serif">
            Rather than replacing diagnostic or medical evaluation, Nadi Pariksha offers an Ayurvedic perspective that
            can contribute to a more personalized understanding of the child.
          </p>
          <GoldDivider className="!mx-0 mt-8" />
        </Reveal>

        <Reveal delay={0.12}>
          <p className="mb-4 text-[11px] font-semibold tracking-[0.24em] uppercase text-[#5C6E62]">
            Video · Nadi Pariksha Explained
          </p>
          <YouTubeEmbed
            testid="nadi-pariksha-video"
            embedId="QNybroj-dmY"
            title="Nadi Pariksha Explained — Sree Prathama Ayurvedam"
          />
        </Reveal>
      </div>
    </section>
  );
}
